import 'Assets/css/app.min.css'
import 'Assets/css/cn/miando.css'
require("Assets/js/footer.js");